import HeaderImg from 'assets/header.png'
import LaurelCrown from 'assets/laurel-crown.svg'
export { HeaderImg, LaurelCrown }
